import { render, staticRenderFns } from "./CampaignsSettings.vue?vue&type=template&id=3f43e0d1&scoped=true&"
import script from "./CampaignsSettings.vue?vue&type=script&lang=js&"
export * from "./CampaignsSettings.vue?vue&type=script&lang=js&"
import style0 from "./CampaignsSettings.vue?vue&type=style&index=0&id=3f43e0d1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f43e0d1",
  null
  
)

export default component.exports